import React from "react"
import { ExtratoPixFornecedorInicial } from "../models/extratoPixFornecedorModel"
import type { ExtratoPixFornecedorModel } from "../models/extratoPixFornecedorModel"
import type { ExtratoPixFornecedorActions } from "./extratoPixFornecedorActions"

interface ExtratoPixFornecedorContextValue {
    dados: ExtratoPixFornecedorModel
    dispatch: React.Dispatch<ExtratoPixFornecedorActions>
    erroCarregamento: string | null
    carregarExtrato: () => Promise<void>
}

export const ExtratoPixFornecedorContext =
    React.createContext<ExtratoPixFornecedorContextValue>({
        dados: ExtratoPixFornecedorInicial,
        dispatch: () => undefined,
        erroCarregamento: null,
        carregarExtrato: async () => undefined,
    })
